import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import { useMediaAsset } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SoftwareCategoryFirstScreen',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



const { getAssetUrl } = useMediaAsset();

return { __sfc: true,getAssetUrl, CdnImg, handleImageSrc, handleImageAlt }
}

})